import { ParkingLotSectionDriveIn, ParkingLotSectionWithReservation } from '../../../../domain/parking';

interface ParkingLotCardConfiguration {
  header: {
    i18n: string;
    backgroundColor: string;
    color: string;
  };
  subHeader: {
    i18n: string;
  };
  tooltipDetails: {
    i18n: string;
  }[];
}

export const PARKING_LOT_CARD_CONFIGURATION_MAP: Record<
  ParkingLotSectionWithReservation | ParkingLotSectionDriveIn,
  ParkingLotCardConfiguration
> = {
  [ParkingLotSectionWithReservation.Closest]: {
    header: {
      i18n: 'parking_service.parkings.closest_to_terminal',
      backgroundColor: 'rgba(102, 161, 184, 1)',
      color: '#FFFFFF',
    },
    subHeader: {
      i18n: 'parking_service.parking_descriptions.closest_to_terminal',
    },
    tooltipDetails: [
      { i18n: 'parking_service.details.steps_away_from_CBX' },
      { i18n: 'parking_service.details.convenient' },
    ],
  },
  [ParkingLotSectionWithReservation.Premium]: {
    header: {
      i18n: 'parking_service.parkings.premium_parking',
      backgroundColor: 'rgba(226, 56, 149, 1)',
      color: '#FFFFFF',
    },
    subHeader: {
      i18n: 'parking_service.parking_descriptions.premium_parking',
    },
    tooltipDetails: [
      { i18n: 'parking_service.details.A_B_3_5_min_walk_from_CBX' },
      { i18n: 'parking_service.details.C_8_15_min_walk_from_CBX' },
    ],
  },
  [ParkingLotSectionWithReservation.CoveredPremium]: {
    header: {
      i18n: 'parking_service.parkings.covered_parking',
      backgroundColor: 'rgba(240, 83, 45, 1)',
      color: '#FFFFFF',
    },
    subHeader: {
      i18n: 'parking_service.parking_descriptions.covered_parking',
    },
    tooltipDetails: [
      { i18n: 'parking_service.details.5_8_min_walk_from_CBX' },
      { i18n: 'parking_service.details.covered' },
      { i18n: 'parking_service.details.convenient' },
    ],
  },
  [ParkingLotSectionWithReservation.Economy]: {
    header: {
      i18n: 'parking_service.parkings.economy_parking',
      backgroundColor: 'rgba(244, 225, 108, 1)',
      color: '#FFFFFF',
    },
    subHeader: {
      i18n: 'parking_service.parking_descriptions.economy_parking',
    },
    tooltipDetails: [
      { i18n: 'parking_service.details.8_15_min_walk_from_CBX' },
      { i18n: 'parking_service.details.unpaved' },
    ],
  },
  [ParkingLotSectionDriveIn.Standard]: {
    header: {
      i18n: 'parking_service.parkings.standard_parking',
      backgroundColor: 'rgba(0, 151, 137, 1)',
      color: '#FFFFFF',
    },
    subHeader: {
      i18n: 'parking_service.parking_descriptions.standard_parking',
    },
    tooltipDetails: [
      { i18n: 'parking_service.details.8_15_min_walk_from_CBX' },
      { i18n: 'parking_service.details.seasonal_shuttle_to_terminal' },
    ],
  },
  [ParkingLotSectionDriveIn.Street]: {
    header: {
      i18n: 'parking_service.parkings.street_parking',
      backgroundColor: '#F498C0',
      color: '#FFFFFF',
    },
    subHeader: {
      i18n: 'parking_service.parking_descriptions.street_parking',
    },
    tooltipDetails: [
      { i18n: 'parking_service.details.8_15_min_walk_from_CBX' },
      { i18n: 'parking_service.details.seasonal_shuttle_to_terminal' },
    ],
  },
};
